<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="box">
      <router-link
        to="/Top"
      >
        <p style="margin-bottom:0px">Art Collection House</p>
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarText"
        aria-controls="navbarText"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"/>
      </button>
    </div>
    <div
      id="navbarText"
      class="collapse navbar-collapse">
      <ul class="navbar-nav mr-auto">
        <!--<li class="nav-item active">
          <router-link
            to="/Top"
            class="nav-link inactive"
          >
            <p>Home</p>
          <span class="sr-only">(current)</span></router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/PageManagement"
            class="nav-link inactive"
          >
            <p>Page Management</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/M0001User"
            class="nav-link inactive"
          >
            <p>User</p>
          </router-link>
        </li>-->
      </ul>
      <b-nav-item-dropdown
        text="Admin"
        style="list-style-type: none;"
        right>
        <b-dropdown-item>
          <router-link
            to="/ChangePassword"
          >
            <p style="margin-bottom:0px">更改密碼</p>
        </router-link></b-dropdown-item>
      </b-nav-item-dropdown>
      <!--<a
        class="nav-link"
        data-toggle="dropdown"
        to="/Sample1">
        <i class="fa fa-user-circle-o "/>Admin
      </a>-->
      <div class="box2">
        <a
          class="nav-link"
          data-toggle="dropdown"
          href="/"
          @click="logout">
          <i
            class="fa fa-sign-out "
          />

        <!-- Message End -->
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      username: localStorage.getItem('username')
    }
  },
  computed: {

  },
  methods: {
    logout () {
      return this.$store.dispatch('Auth/logout', this.authInfo)
        .then(() => {
          this.$router.push({ path: '/' })
        })
        .catch(err => this.throwReject(err))
    },
    openNav () {
      var sidebar = document.getElementById('sidebar')
      if (sidebar.classList.contains('sidebar-collapse')) {
        sidebar.classList.replace('sidebar-collapse', 'sidebar-open')
      } else {
        sidebar.classList.replace('sidebar-open', 'sidebar-collapse')
      }
    }
  }
}
</script>
<style scoped>
.box{
    margin-left: 50px;
}
.box2{
    margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/OrHeader.vue